import { render, staticRenderFns } from "./spuSelectComponent.vue?vue&type=template&id=eb8bc9e0&"
import script from "./spuSelectComponent.vue?vue&type=script&lang=js&"
export * from "./spuSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb8bc9e0')) {
      api.createRecord('eb8bc9e0', component.options)
    } else {
      api.reload('eb8bc9e0', component.options)
    }
    module.hot.accept("./spuSelectComponent.vue?vue&type=template&id=eb8bc9e0&", function () {
      api.rerender('eb8bc9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goodsspu/spuSelectComponent.vue"
export default component.exports